var _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg006Reports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 540 540",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "334.1 13.5 334.1 141.8 462.4 141.8 334.1 13.5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M334.1,173.8c-17.7,0-32.1-14.4-32.1-32.1V13.5H109.7c-17.7,0-32.1,14.4-32.1,32.1v448.9c0,17.7,14.4,32.1,32.1,32.1h320.6c17.7,0,32.1-14.4,32.1-32.1V173.8h-128.2ZM205.9,462.4h-64.1v-96.2h64.1v96.2ZM302.1,462.4h-64.1v-160.3h64.1v160.3ZM398.2,462.4h-64.1v-224.4h64.1v224.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg006Reports);
export default __webpack_public_path__ + "static/media/006-reports.0ee112cf2cabde4939aeae6bc3917b89.svg";
export { ForwardRef as ReactComponent };